import { ActionType, createAction } from 'typesafe-actions';

export const ANNOTATION_STACK = 'annotationStack';
export const ANNOTATIONS_QUERY = 'annotationsQuery';
export const ANNOTATIONS_QUERY_FOR_BROWSER_TAB =
  'annotationsQueryForBrowserTab';
export const WORKSPACES = 'workspaces';
export const STATISTICS_QUERY = 'statisticsQuery';
export const BILLING_USAGE_QUERY = 'billingUsageQuery';
export const BILLING_OVERVIEW_QUERY = 'billingOverviewQuery';
export const EXTENSIONS_ADVANCED_SETTINGS_EXPANDED =
  'extensions:advancedSettingsExpanded';
export const ACTIVITIES_QUERY = 'activities:logsQuery';
export const QUEUE_MANAGER_QUERY = 'queueManager:query';
export const RULES_EXECUTION_LOGS_QUERY = 'rulesExecutionLogs:query';
export const USERS_LIST_QUERY = 'users:listQuery';
export const HOOK_LIST_QUERY = 'hookListQuery';
export const DOCUMENTS_QUERY = 'documents:query';
export const EMAILS_QUERY = 'emails:query';
export const DOCUMENTS_SEARCH_AFTER_KEY = 'documents:nextCursors';
export const DOCUMENTS_QUERY_FOR_BROWSER_TAB = 'documents:queryForBrowserTab';
export const DOCUMENTS_SIDEBAR_IS_OPEN = 'documents:sidebarIsOpen';
export const DOCUMENTS_EXPORT_WITH_DOWNLOAD = 'documents:exportWithDownload';
export const DOCUMENTS_SIDEBAR_WIDTH = 'documents:sidebarWidth';
export const FIELDS_SECTIONS_EXPANDED = 'fields:sectionsExpanded';
export const MEMBERSHIP_ID = 'membership:id';
export const DATASETS_TASKS_KEY = 'datasets:tasks';
export const DATASETS_TABLE_STATE = 'datasets:tableState';
export const CONFIGURATION_CHANGELOG_QUERY = 'configurationChangelog:query';
export const COLLECTION_ID = 'collectionId';
export const REQUEST_DASHBOARD_QUERY = 'requestDashboard:query';

export const storedUserData: StorageKey[] = [
  ANNOTATION_STACK,
  ANNOTATIONS_QUERY,
  BILLING_USAGE_QUERY,
  BILLING_OVERVIEW_QUERY,
  HOOK_LIST_QUERY,
  STATISTICS_QUERY,
  WORKSPACES,
  ACTIVITIES_QUERY,
  QUEUE_MANAGER_QUERY,
  RULES_EXECUTION_LOGS_QUERY,
  USERS_LIST_QUERY,
  DOCUMENTS_QUERY,
  DOCUMENTS_SEARCH_AFTER_KEY,
  MEMBERSHIP_ID,
  DATASETS_TASKS_KEY,
  DATASETS_TABLE_STATE,
  CONFIGURATION_CHANGELOG_QUERY,
  COLLECTION_ID,
  REQUEST_DASHBOARD_QUERY,
];

export type StorageKey =
  | 'annotationStack'
  | 'annotationsQuery'
  | 'navigateToNext'
  | 'locale'
  | 'workspaces'
  | 'statisticsQuery'
  | 'billingUsageQuery'
  | 'billingOverviewQuery'
  | typeof EXTENSIONS_ADVANCED_SETTINGS_EXPANDED
  | typeof ACTIVITIES_QUERY
  | typeof QUEUE_MANAGER_QUERY
  | typeof RULES_EXECUTION_LOGS_QUERY
  | typeof USERS_LIST_QUERY
  | typeof HOOK_LIST_QUERY
  | typeof DOCUMENTS_QUERY
  | typeof EMAILS_QUERY
  | typeof DOCUMENTS_SEARCH_AFTER_KEY
  | typeof DOCUMENTS_EXPORT_WITH_DOWNLOAD
  | typeof MEMBERSHIP_ID
  | typeof DATASETS_TASKS_KEY
  | typeof DATASETS_TABLE_STATE
  | typeof CONFIGURATION_CHANGELOG_QUERY
  | typeof COLLECTION_ID
  | typeof REQUEST_DASHBOARD_QUERY;

export const setItem = createAction(
  'STORAGE_SET_ITEM',
  (_key: StorageKey, value: string) => value,
  (key: StorageKey, _value: string) => ({ key })
)<string, { key: StorageKey }>();

export const removeItem = createAction(
  'STORAGE_REMOVE_ITEM',
  undefined,
  (key: StorageKey) => ({
    key,
  })
)<undefined, { key: StorageKey }>();

export const removeItems = createAction(
  'STORAGE_REMOVE_ITEMS',
  undefined,
  (keys: StorageKey[]) => ({
    keys,
  })
)<undefined, { keys: StorageKey[] }>();

export type LocalStorageActions = ActionType<
  typeof setItem | typeof removeItem | typeof removeItems
>;
